
export default {
  props: {
    text: {
      // Prop使用
      type: String,
      default: ''
    },
    dis: {
      // 是否禁用true禁用---false不禁用
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: ''
    }
  },
  methods: {
    open() {
      // 按钮点击事件
      if (this.dis) return
      this.$emit('todo')
    }
  }
}
